import React from 'react'

// ArComponents
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArPostSimple from 'src/components/ArPostSimple/ArPostSimple'
import ArBenefits from 'src/components/ArBenefits/ArBenefits'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaDataCommon from 'src/data/DataCommon'
import DaPagePricing from 'src/data/PagePricing'
import ArPartners from 'src/components/ArPartners/ArPartners'
import ArCTASection from 'src/components/ArCTASection/ArCTASection'
import ArTestimonials from 'src/components/ArTestimonials/ArTestimonials'
import routesConfig from 'src/routes.config'

class PricingPage extends React.Component {
  render () {
    return (
      <React.Fragment>

        <ArSeo
          title={DaPagePricing.metadata.title}
          description={DaPagePricing.metadata.desc}
          path={routesConfig.pricing()}
        />

        {(() => {
          const { image, title, cta, description } = DaPagePricing.ArHeroHeader
          return (
            <ArHeroHeader
              variant="pricing"
              image={image}
              title={title}
              cta={cta}
              description={description}
            />
          )
        })()}

        {(() => {
          const { title, description } = DaPagePricing.ArPostSimple
          return (
            <ArPostSimple
              title={title}
              description={description}
            />
          )
        })()}

        {(() => {
          const { title, description, benefits } = DaPagePricing.ArBenefits
          return (
            <ArBenefits
              title={title}
              description={description}
              benefits={benefits}
              scCompact={true}
            />
          )
        })()}

        {(() => {
          const { title, logos } = DaDataCommon.ArPartners

          return (
            <ArPartners title={title} logos={logos} />
          )
        })()}

        {(() => {
          return (
            <ArTestimonials testimonials={DaDataCommon.ArTestimonials} />
          )
        })()}

        {(() => {
          const { title, cta, backgroundColor } = DaDataCommon.ArCTASection

          return (
            <ArCTASection title={title} cta={cta} scBackgroundColor={backgroundColor} />
          )
        })()}

      </React.Fragment>
    )
  }
}

export default PricingPage
